// extracted by mini-css-extract-plugin
export default {"Tabs":"styles_Tabs__Bx+yz","activeTabBorder":"styles_activeTabBorder__AMz+l","tab":"styles_tab__sqbTJ","active":"styles_active__En9b9"};